"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OrderTotalContentState = /** @class */ (function () {
    function OrderTotalContentState() {
    }
    return OrderTotalContentState;
}());
exports.default = OrderTotalContentState;
//# sourceMappingURL=OrderTotalContentState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/atoms/OrderTotalContent/OrderTotalContentState.js
// module id = 2375
// module chunks = 8